import moment from 'moment-timezone';

export const DAY_HOURS_WITH_ZERO = Array.from({ length: 24 }, (_, i) => i);

export const SECONDS_AND_MINUTES_WITH_ZERO = Array.from({ length: 60 }, (_, i) => i);

export const WEEK_DAYS_STRING_FORMAT = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const WEEK_DAYS_OBJECT_FORMAT = WEEK_DAYS_STRING_FORMAT.map((e, i) => ({
  longName: e,
  shortName: e.substring(0, 3),
  id: i + 1,
}));

export const WEEKDAYS_OBJECT_FORMAT = WEEK_DAYS_OBJECT_FORMAT.slice(0, 5);

export const WEEKEND_DAYS_OBJECT_FORMAT = WEEK_DAYS_OBJECT_FORMAT.slice(5);

export const UTC = 'UTC';

export const YEAR = 'year';
export const YEAR_FORMAT = 'YYYY';
export const YEAR_2020 = 2020;

export const DEFAULT_TIMEZONE = 'Etc/UTC';
export const VALID_TIMEZONES = moment.tz.names();

export const MOMENT_DAY = 'day';
export const MOMENT_MILLISECOND = 'millisecond';
export const MOMENT_MINUTE = 'minute';

export const INVERTED_DATE_FORMAT = 'YYYY-MM-DD';
export const HMS_FORMAT = 'HH[h] mm[m] ss[s]';

export const LABEL_H24 = 'h24';
export const WEEKDAYS = 'weekdays';
export const WEEKEND = 'weekend';

export const HOURMINFORMAT = 'HH:mm';
export const HOUR_LABEL = 'hh';

export const START_VALUE = '00';
export const START_HALF_MINUTE = '30';
export const END_HALF_MINUTE = '29';
export const END_MINUTE = '59';
export const END_HOUR = '23';
export const START_DAY = `${START_VALUE}:${START_VALUE}`;
export const START_HOUR = `${START_DAY}:${START_VALUE}`;
export const END_DAY = `${END_HOUR}:${END_MINUTE}`;

export const WIDGET_ROUNDLINE_FORMAT = 'MMM Do YYYY';

export const DEFAULT_FORMAT_TIMEDATE = 'dd/MM/yyyy HH:mm:ss';

export const LAST_24_HOURS = 'last24hours';
export const LAST_WEEK = 'lastWeek';
export const LAST_MONTH = 'lastMonth';
export const LAST_SIX_MONTHS = 'past6months';

export const HOUR = 'hour';
export const THIRTY_MIN = 'thirtymin';

export const MONTH = 'month';

export const timeFormatMapper = {
  month: 'MMM YYYY',
  day: 'DD MMM YYYY',
  hour: 'DD-MMM-YY HH:mm',
};
